import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { CameraAccessProps } from '@components/atoms/camera-access-default/types';
import { Typography } from '@components/atoms/typography';

import { CloseIcon, ErrorMarkIcon } from '../../icons';
import { Button } from '../button';
import { Icon } from '../icon';

import { Container } from './styles';

export const CameraAccessDefault: React.FC<CameraAccessProps> = ({ title, onClose, hasCloser }) => {
    const { t } = useTranslation();

    const actualTitle = useMemo(() => {
        if (!title) {
            return (
                <Typography variant='h2' color='text-main' tag='h4' className='camera-access-title'>
                    {t('camera.cantUseCamera')}
                </Typography>
            );
        }

        if (typeof title === 'string') {
            return (
                <Typography variant='h2' color='text-main' tag='h4' className='camera-access-title'>
                    {title}
                </Typography>
            );
        }

        return title;
    }, [t, title]);

    return (
        <Container className='camera-access'>
            <div className='camera-access-wrapper'>
                <ErrorMarkIcon className='camera-access-icon' />
                {actualTitle}
                {hasCloser && (
                    <Icon
                        icon={<CloseIcon />}
                        $clickable={true}
                        className='camera-access-close-icon'
                        onClick={onClose}
                    />
                )}

                <p className='camera-access-subtitle'>{t('camera.hereAreAFewThingsYouCanTry')}:</p>
                <ul className='camera-access-list'>
                    <Typography
                        variant='text'
                        color='text-light'
                        tag='li'
                        className='camera-access-text'
                    >
                        {t('camera.grantAccessToTheCamera')}
                    </Typography>
                    <Typography
                        variant='text'
                        color='text-light'
                        tag='li'
                        className='camera-access-text'
                    >
                        {t('camera.restartYourBrowser')}
                    </Typography>
                    <Typography
                        variant='text'
                        color='text-light'
                        tag='li'
                        className='camera-access-text'
                    >
                        {t('camera.tryAnotherBrowser')}
                    </Typography>
                </ul>
                <Icon
                    icon={<CloseIcon />}
                    $clickable={true}
                    className='camera-access-close-icon'
                    onClick={onClose}
                />
                <Button
                    className='camera-access-actions'
                    variant='secondary'
                    onClick={onClose}
                    size='xl'
                >
                    {t('common.cancel')}
                </Button>
            </div>
        </Container>
    );
};
